import { createSelector } from 'reselect'
import { getPageData, getPageParams } from 'selectors/page'

import { searchIndice, sortOptions } from '../helpers'
export { getAlgoliaUserToken } from 'selectors/user/cookie'
import { SAArtwork } from 'types/Artwork'
export const getSelectedPromo = createSelector(
  getPageData,
  (pageData): Record<string, any> => pageData.selectedPromo || {}
)
export const getSelectedPromoCode = createSelector(
  getSelectedPromo,
  (selectedPromo): string => selectedPromo.promoCode || ''
)
export const getSelectedPromoDiscount = createSelector(
  getSelectedPromo,
  (selectedPromo): number => selectedPromo.discount || 0
)
export const getSelectedPromoHash = createSelector(
  getSelectedPromo,
  (selectedPromo): string => selectedPromo.hash || ''
)
export const getAlgoliaResults = createSelector(
  getPageData,
  (pageData): Record<string, any> => pageData.algoliaResults || {}
)
export const getHits = createSelector(
  getAlgoliaResults,
  (algoliaResults): Record<string, any> => algoliaResults.hits || {}
)
export const getHitsResults = createSelector(
  getHits,
  (hits): ReadonlyArray<SAArtwork> => hits.results || []
)

export const getQueryId = createSelector(
  getAlgoliaResults,
  (algoliaResults): string => algoliaResults.queryID || ''
)
export const getSort = createSelector(
  getPageParams,
  (pageParams): string => pageParams.sort || 'default'
)
export const getSortIndice = createSelector([getSort], (sort): string => {
  const currentOption = sortOptions.find((option) => option.value === sort)
  return currentOption ? currentOption.indice : searchIndice
})
